var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowThickUpAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00A3E0",
    d: "m7.35373,0.62584l0.098,0.06l0.023,0.012a0.508,0.508 0 0 1 0.152,0.105l4.667,4.667a0.814,0.814 0 0 1 0,1.17a0.814,0.814 0 0 1 -1.17,0l-3.249,-3.248l0,9.33c0,0.487 -0.345,0.833 -0.833,0.833s-0.833,-0.346 -0.833,-0.834l0,-9.33l-3.249,3.249a0.814,0.814 0 0 1 -1.17,0a0.878,0.878 0 0 1 -0.248,-0.585c0,-0.197 0.094,-0.43 0.248,-0.585l4.667,-4.667c0.123,-0.123 0.186,-0.175 0.293,-0.187a0.913,0.913 0 0 1 0.604,0.01z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowThickUpAlt);
export default __webpack_public_path__ + "static/media/arrow-thick-up-alt.25dad4032ce605e36b8a5e98722534a1.svg";
export { ForwardRef as ReactComponent };